var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import { RuleType } from "@@/Schema";
import { makeObservable, observable, action } from "mobx";
import { RuleParamUI, RuleParamUICondition, RuleParamUIConditionParam, RuleUI } from "./RuleBuilderStore";
export class DataRuleBuilderState {
    constructor() {
        this.show = false;
        this.zindex = 0;
        this.rulecoid = "";
        this.saving = false;
        this.ruleByColumn = new Map();
        this.manualrule = true;
        this.activeruleid = "";
        this.rules = [];
        this.activeparamui = undefined;
        this.activecontype = "schema";
        this.activeruleindex = -1;
        this.atciverule = undefined;
        this.activeparam = "";
        this.manualrulebyColumn = new Map();
        this.activeparamitems = [];
        this.activecondition = "and";
        makeObservable(this);
    }
    setActiveParamItems(items) {
        this.activeparamitems.splice(0, this.activeparamitems.length);
        this.activeparamitems.push(...items);
    }
    setActiveConditionType(type) {
        this.activecondition = type;
    }
    setActiveConType(type) {
        this.activecontype = type;
    }
    setManualRule(mn) {
        this.manualrule = mn;
    }
    deleteRule(id) {
        // lets remove this now!!
        for (let i = 0; i < this.rules.length; i++) {
            if (this.rules[i].id === id) {
                this.deleteRuleByIndex(i);
                break;
            }
        }
    }
    convertRuleUIsToRules() {
        var _a;
        // this can be some deletion rule too ?
        if (this.rulecoid !== '' && this.rules.length > 0) {
            this.ruleByColumn.set(this.rulecoid, [...this.rules]);
        }
        if (this.rulecoid !== '') {
            this.manualrulebyColumn.set(this.rulecoid, this.manualrule);
        }
        const keys = Array.from(this.ruleByColumn.keys());
        const colrules = [];
        for (const key of keys) {
            const rules = this.ruleByColumn.get(key);
            if (rules && rules.length > 0) {
                const cr = this.convertRuleUiToRule(rules, key);
                cr.manualrule = (_a = this.manualrulebyColumn.get(key)) !== null && _a !== void 0 ? _a : true;
                colrules.push(cr);
            }
        }
        return colrules;
    }
    reset() {
        this.ruleByColumn.clear();
        this.rulecoid = "";
        this.rules.splice(0, this.rules.length);
        this.activeruleid = "";
        this.activeruleindex = -1;
        this.atciverule = undefined;
        this.activecondition = "and";
        this.activecontype = "schema";
        this.activeparam = "";
        this.activeparamui = undefined;
        this.manualrulebyColumn.clear();
        this.setManualRule(false);
    }
    setRules(rules) {
        var _a;
        this.reset();
        for (const rul of rules) {
            const cid = rul.colid;
            const uirules = this.convertRulesToRuleUIParam(rul.rule);
            this.ruleByColumn.set(cid, uirules);
            this.manualrulebyColumn.set(cid, (_a = rul.manualrule) !== null && _a !== void 0 ? _a : false);
        }
        if (rules.length > 0) {
            this.setRuleColId(rules[0].colid);
        }
    }
    convertRuleUiToRule(rui, id) {
        const srules = [];
        for (const r of rui) {
            const rconds = [];
            if (r.ruleconds) {
                if (r.ruleconds.length > 0) {
                    for (const rc of r.ruleconds) {
                        if (rc.conditionparam.length > 0) {
                            const rcp = [];
                            for (const rcpp of rc.conditionparam) {
                                if (rcpp.comp) {
                                    const pp = {
                                        leftcond: rcpp.leftcondition,
                                        comp: rcpp.comp,
                                        rightcond: rcpp.rightcondition,
                                        rightschemacon: rcpp.rightschemacol
                                    };
                                    rcp.push(pp);
                                }
                            }
                            if (rcp.length > 0) {
                                rconds.push({
                                    contype: rc.condtype,
                                    prevtype: rc.prevresult,
                                    params: rcp,
                                });
                            }
                        }
                    }
                }
            }
            const myparsm = [];
            for (const rp of r.params) {
                const conds = [];
                if (rp.conds.length > 0) {
                    for (const rc of rp.conds) {
                        if (rc.conditionparam.length > 0) {
                            const rcp = [];
                            for (const rcpp of rc.conditionparam) {
                                if (rcpp.comp) {
                                    const pp = {
                                        leftcond: rcpp.leftcondition,
                                        comp: rcpp.comp,
                                        rightcond: rcpp.rightcondition,
                                        rightschemacon: rcpp.rightschemacol
                                    };
                                    rcp.push(pp);
                                }
                            }
                            if (rcp.length > 0) {
                                conds.push({
                                    contype: rc.condtype,
                                    prevtype: rc.prevresult,
                                    params: rcp,
                                });
                            }
                        }
                    }
                }
                myparsm.push({
                    type: rp.type,
                    value: rp.value,
                    conds: conds,
                    matchingrow: rp.addmatchingcond,
                    typeunits: rp.typeunits
                });
            }
            const myrule = {
                type: r.type,
                params: myparsm,
                conds: rconds,
                prevstageresult: r.prevstagerule,
            };
            srules.push(myrule);
        }
        const crule = {
            colid: id,
            rule: srules,
        };
        return crule;
    }
    convertRulesToRuleUIParam(rules) {
        var _a, _b;
        const ruleui = [];
        for (const r of rules) {
            const ru = new RuleUI(LetrwingCrypto.getUUID());
            ru.setType(r.type);
            ru.setPrevStageType((_a = r.prevstageresult) !== null && _a !== void 0 ? _a : r.type);
            if (r.conds) {
                for (const cc of r.conds) {
                    const cond = new RuleParamUICondition();
                    cond.setPrevCond(cc.prevtype);
                    cond.setCondition(cc.contype);
                    for (const ccp of cc.params) {
                        const ck = new RuleParamUIConditionParam();
                        ck.setComp(ccp.comp);
                        ck.setLeftCond(ccp.leftcond);
                        ck.setRightCond(ccp.rightcond);
                        ck.setRightSchemaCol(ccp.rightschemacon);
                        cond.addCondParam(ck);
                    }
                    ru.addRuleCond(cond);
                }
            }
            for (const rp of r.params) {
                const up = new RuleParamUI();
                if (rp.conds && rp.conds.length > 0) {
                    for (const cc of rp.conds) {
                        const cond = new RuleParamUICondition();
                        cond.setPrevCond(cc.prevtype);
                        cond.setCondition(cc.contype);
                        for (const ccp of cc.params) {
                            const ck = new RuleParamUIConditionParam();
                            ck.setComp(ccp.comp);
                            ck.setLeftCond(ccp.leftcond);
                            ck.setRightCond(ccp.rightcond);
                            ck.setRightSchemaCol(ccp.rightschemacon);
                            cond.addCondParam(ck);
                        }
                        up.addCondition(cond);
                    }
                }
                up.setActionForMatchingCond((_b = rp.matchingrow) !== null && _b !== void 0 ? _b : RuleType.Add);
                up.setType(rp.type);
                up.setValue(rp.value);
                ru.params.push(up);
            }
            ruleui.push(ru);
        }
        return ruleui;
    }
    deleteRuleByIndex(index) {
        const delitems = this.rules.splice(index, 1);
        if (this.rulecoid !== '' && this.ruleByColumn.has(this.rulecoid) && this.rules.length === 0) {
            this.ruleByColumn.delete(this.rulecoid);
        }
        for (const di of delitems) {
            if (this.activeruleid === di.id) {
                this.setActiveRuleId("");
                this.setActiveRuleIndex(-1);
                this.atciverule = undefined;
            }
        }
    }
    addRule(rule) {
        this.rules.push(rule);
    }
    setShow(show) {
        this.show = show;
    }
    setZIndex(index) {
        this.zindex = index;
    }
    setActiveParam(id) {
        this.activeparam = id;
    }
    setSaving(sav) {
        this.saving = sav;
    }
    setRuleColId(id) {
        var _a;
        if (this.rulecoid === id)
            return;
        if (this.rulecoid !== '') {
            // lets just copy that edits now
            this.ruleByColumn.set(this.rulecoid, [...this.rules]);
            this.manualrulebyColumn.set(this.rulecoid, this.manualrule);
        }
        this.rulecoid = id;
        this.rules.splice(0, this.rules.length);
        const erules = this.ruleByColumn.get(id);
        if (erules) {
            this.rules.push(...erules);
        }
        this.setManualRule((_a = this.manualrulebyColumn.get(this.rulecoid)) !== null && _a !== void 0 ? _a : true);
        this.setActiveRuleId("");
        this.setActiveRuleIndex(-1);
        this.atciverule = undefined;
    }
    setActiveRuleIndex(index) {
        this.activeruleindex = index;
    }
    setActiveRuleId(id) {
        this.activeruleid = id;
    }
    clearRulesForCol(id) {
        this.ruleByColumn.delete(id);
        if (this.rulecoid === id) {
            this.rules.splice(0, this.rules.length);
            this.activeruleid = "";
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], DataRuleBuilderState.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DataRuleBuilderState.prototype, "zindex", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DataRuleBuilderState.prototype, "rulecoid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DataRuleBuilderState.prototype, "saving", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], DataRuleBuilderState.prototype, "ruleByColumn", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DataRuleBuilderState.prototype, "manualrule", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DataRuleBuilderState.prototype, "activeruleid", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], DataRuleBuilderState.prototype, "rules", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], DataRuleBuilderState.prototype, "activecontype", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DataRuleBuilderState.prototype, "activeruleindex", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DataRuleBuilderState.prototype, "activeparam", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], DataRuleBuilderState.prototype, "manualrulebyColumn", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], DataRuleBuilderState.prototype, "activeparamitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DataRuleBuilderState.prototype, "activecondition", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], DataRuleBuilderState.prototype, "setActiveParamItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DataRuleBuilderState.prototype, "setActiveConditionType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DataRuleBuilderState.prototype, "setActiveConType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DataRuleBuilderState.prototype, "setManualRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DataRuleBuilderState.prototype, "deleteRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DataRuleBuilderState.prototype, "convertRuleUIsToRules", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DataRuleBuilderState.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], DataRuleBuilderState.prototype, "setRules", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], DataRuleBuilderState.prototype, "deleteRuleByIndex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [RuleUI]),
    __metadata("design:returntype", void 0)
], DataRuleBuilderState.prototype, "addRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DataRuleBuilderState.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], DataRuleBuilderState.prototype, "setZIndex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DataRuleBuilderState.prototype, "setActiveParam", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DataRuleBuilderState.prototype, "setSaving", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DataRuleBuilderState.prototype, "setRuleColId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], DataRuleBuilderState.prototype, "setActiveRuleIndex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DataRuleBuilderState.prototype, "setActiveRuleId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DataRuleBuilderState.prototype, "clearRulesForCol", null);
